import { ArchivingKeyword }      from '@app/modules/keyword/models/archiving-keyword.model';
import { KeywordEntityConfig }   from '@app/modules/keyword/presets/keyword-entity-config.model';
import { EntityActionEventEnum } from '@models/entity.model';


// ENUMS #############################################################
export enum KeywordPresetEnum {
	CONFIGURATION = 'configuration',
	BUSINESS_PREMISES_DETAIL_ARCHIVING_OPEN_ARCHIVE = 'businessPremisesDetailArchivingOpenArchive',
}


// TYPES #############################################################
export type KeywordProductTypes =
	ArchivingKeyword;

export type ArchivingKeywordPropertyNames = {
	[ key in keyof ArchivingKeyword ]: keyof ArchivingKeyword;
};


// INTERFACES ########################################################
export interface IKeywordEntityActionEvent {
	keyword: KeywordProductTypes;

	action: EntityActionEventEnum;

	keywordEntityConfig?: KeywordEntityConfig;
}


// ENTITIES ##########################################################
// MODEL USED FOR TRANSITION APP<->API (TransitionalModelObject)
export class BusinessPremisesByKeywordTMO {
	public id?: string = undefined;
}

// MODEL USED IN APPLICATION (with additional properties)
export class BusinessPremisesByKeyword extends BusinessPremisesByKeywordTMO {}

